module.exports = "<div class=\"iframe-wrapper__container\"></div>"